module.exports = __webpack_public_path__ + "img/flags/SX.a959e40.png";